import React from 'react';
import './UIHomeView.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSignsPost, faComments, faBook} from '@fortawesome/free-solid-svg-icons';
import germany from "../../../assets/germany_map.png";
import UIFooter from "../_commons/Footer/UIFooter";
import { VILLAGES } from "../../../data/villages";
import UIBrand from "../_commons/Brand/UIBrand";

export default class UIHomeView extends React.Component {

    constructor(props) {
        super(props);
        this.state = { menuOpen: false, villageIndex: 0 };
        this.toggleMenu  = this.toggleMenu.bind(this);
        this.villageNext = this.villageNext.bind(this);
        this.villagePrev = this.villagePrev.bind(this);
        this.villagesRef = React.createRef();
    }

    toggleMenu() {
        this.setState(s => ({ menuOpen: !s.menuOpen }));
    }

    getVisibleCount() {
        return window.innerWidth >= 1024 ? 3 : 1;
    }

    villageNext(total) {
        const visible = this.getVisibleCount();
        this.setState(s => ({
            villageIndex: Math.min(s.villageIndex + 1, total - visible)
        }), () => this.scrollVillages());
    }

    villagePrev() {
        this.setState(s => ({
            villageIndex: Math.max(s.villageIndex - 1, 0)
        }), () => this.scrollVillages());
    }

    scrollVillages() {
        const container = this.villagesRef.current;
        if (!container) return;
        const card = container.querySelector('.home-village-card');
        if (!card) return;
        const style = getComputedStyle(container);
        const gap = parseFloat(style.gap) || parseFloat(style.columnGap) || 24;
        const cardWidth = card.offsetWidth + gap;
        try {
            container.scrollTo({ left: this.state.villageIndex * cardWidth, behavior: 'smooth' });
        } catch (e) {
            container.scrollLeft = this.state.villageIndex * cardWidth;
        }
    }

    render() {
        const { menuOpen, villageIndex } = this.state;

        const villages = VILLAGES;
        const visible = this.getVisibleCount();
        const canPrev = villageIndex > 0;
        const canNext = villageIndex < villages.length - visible;
        return (
            <div className={"UIHomeView"}>

                {/* ===== HERO / HEADER ===== */}
                <section className="home-hero">

                    {/* Navigation */}
                    <nav className="home-nav">
                        <UIBrand />

                        {/* Desktop Links */}
                        <ul className="home-nav-links">
                            <li><a href="#features" className="active">Funktionen</a></li>
                            <li><a href="#gemeinden">Gemeinden</a></li>
                            <li><a href="#about">Über dorffuchs</a></li>
                        </ul>

                        {/* Hamburger Button (nur mobil) */}
                        <button className="home-nav-hamburger" onClick={this.toggleMenu} aria-label="Menü öffnen">
                            {menuOpen ? '✕' : '☰'}
                        </button>
                    </nav>

                    {/* Mobile Dropdown Menü */}
                    {menuOpen && (
                        <ul className="home-nav-mobile">
                            <li><a href="#features" onClick={this.toggleMenu}>Features</a></li>
                            <li><a href="#gemeinden" onClick={this.toggleMenu}>Gemeinden</a></li>
                            <li><a href="#about" onClick={this.toggleMenu}>Über uns</a></li>
                        </ul>
                    )}

                    {/* Hero Content */}
                    <div className="home-hero-content">
                        <div className="home-hero-text">
                            <h1>Gemeinde erleben. Gemeinsam gestalten</h1>
                            <p>
                                Dorffuchs ist eine kostenlose und werbefreie Gemeinde-App.
                                Geschichte, Neuigkeiten, Veranstaltungen und das Bürgerforum –
                                Digitalisierung für mehr Zusammenhalt und ein aktives Gemeindeleben.
                            </p>
                        </div>
                    </div>

                </section>


                {/* ===== FEATURES SECTION ===== */}
                <section className="home-features" id="features">
                    <div className="home-features-grid">

                        <div className="home-feature-item">
                            <div className="home-feature-icon">
                                <FontAwesomeIcon icon={faBook} />
                            </div>
                            <h3>Meine Gemeinde</h3>
                            <p>Erfahre mehr über deine Gemeinde – ihre Geschichte, aktuelle Situation sowie Zukunftsaussichten und Pläne.</p>
                        </div>

                        <div className="home-feature-item">
                            <div className="home-feature-icon">
                                <FontAwesomeIcon icon={faSignsPost} />
                            </div>
                            <h3>Wegweiser</h3>
                            <p>Wo beantrage ich einen Reisepass? Welche Vereine gibt es? Welche Veranstaltungen stehen an? Antworten auf all das – und noch viel mehr.</p>
                        </div>

                        <div className="home-feature-item">
                            <div className="home-feature-icon">
                                <FontAwesomeIcon icon={faComments} />
                            </div>
                            <h3>Bürgerforum</h3>
                            <p>Schäden melden, diskutieren, austauschen – direkt zwischen Bürgern und Gemeindeverwaltung. Bringe dich aktiv ins Gemeindeleben ein.</p>
                        </div>

                    </div>
                </section>

                {/* ===== DEUTSCHLAND SECTION ===== */}
                <section className="home-germany" id="gemeinden">
                    <h2>Für Gemeinden in ganz Deutschland</h2>
                    <p>Was mit einer Gemeinde beginnt, soll ganz Deutschland verbinden – Dorf für Dorf, Schritt für Schritt.</p>
                    <div className="home-germany-map">
                        <div className="home-germany-map-inner">
                            <img src={germany} alt="Karte von Deutschland" />
                            {[...villages].sort((a, b) => (a.available ? 1 : 0) - (b.available ? 1 : 0)).map((v, i) => v.mapX != null && v.mapY != null && (
                                <div
                                    key={i}
                                    className={`home-germany-pin ${v.available ? 'available' : 'preparing'}`}
                                    style={{ left: `${v.mapX}%`, top: `${v.mapY}%` }}
                                    title={v.title}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="home-village-slider">
                        <button
                            className={`home-village-arrow home-village-arrow-left${!canPrev ? ' disabled' : ''}`}
                            onClick={this.villagePrev}
                            disabled={!canPrev}
                            aria-label="Zurück"
                        >&#8249;</button>

                        <div className="home-germany-villages" ref={this.villagesRef}>
                            {villages.map((v, i) => (
                                <div className="home-village-card" key={i} onClick={() => this.props.onVillageSelect && this.props.onVillageSelect(v)} style={{cursor:'pointer'}}>
                                    <div className="home-village-card-img">
                                        <img src={v.img} alt={v.title} />
                                        <span className={`home-village-badge ${v.available ? 'available' : 'preparing'}`}>
                                            {v.available ? '✓ Verfügbar' : 'In Vorbereitung'}
                                        </span>
                                    </div>
                                    <span className="home-village-title">{v.title}</span>
                                </div>
                            ))}
                        </div>

                        <button
                            className={`home-village-arrow home-village-arrow-right${!canNext ? ' disabled' : ''}`}
                            onClick={() => this.villageNext(villages.length)}
                            disabled={!canNext}
                            aria-label="Weiter"
                        >&#8250;</button>
                    </div>
                </section>

                <section className="home-about" id="about">
                    <div className="home-about-inner">
                        <h2>Über Dorffuchs</h2>
                        <p>
                            Dorffuchs ist eine <strong>kostenlose und werbefreie</strong> Gemeinde-App,
                            die seit Ende 2013 ehrenamtlich entwickelt wird. Ursprünglich als Hochschulprojekt für die Stadt Ettlingen gestartet – damals als App für lokale Sehenswürdigkeiten – wird Dorffuchs nach vielen Jahren ehrenamtlicher Weiterentwicklung im Jahr 2026 endlich der Öffentlichkeit zugänglich gemacht.
                        </p>
                        <p>
                            Es gibt noch viel zu tun – und aufgrund begrenzter Ressourcen schreitet die
                            Entwicklung zwar langsam, aber stetig voran. Wir freuen uns über jeden, der
                            mitmacht und die App mit Leben füllt.
                        </p>
                        <p>
                            Die Dorffuchs-App gliedert sich in zwei Kernbereiche: <b>Meine Gemeinde</b> und <b>Bürgerforum</b>.
                        </p>
                        <p>
                            <h6>Meine Gemeinde</h6>
                            Besonders für neue Bürger bietet Dorffuchs einen schnellen Einstieg ins Gemeindeleben –
                            mit Informationen zu Geschichte, aktuellen Entwicklungen und Zukunftsplänen der Gemeinde.
                        </p>
                        <p>
                            Wo beantrage ich einen Reisepass?
                            Welche Veranstaltungen stehen an?
                            Welche Vereine gibt es in meiner Gemeinde?
                            Antworten auf diese und viele weitere Fragen findest du direkt in der App –
                            und du kannst aktiv dazu beitragen, sie vollständig zu halten.
                        </p>
                        <p>
                            <h6>Bürgerforum</h6>
                            Im Bürgerforum meldest du Schäden, gibst Anzeigen auf, stellst Fragen
                            und diskutierst mit anderen Bürgern.
                        </p>
                        <p>
                            Du hast einen Laden, eine Werkstatt, eine Farm oder bietest Kinderbetreuung an?
                            Präsentiere deinen Betrieb kostenlos in der Dorffuchs-App.
                        </p>
                        <p>
                            <h5>Registrierung</h5>
                            Jede Gemeinde erhält ihre eigene, individuelle App im App-Store oder Google Play-Store. Die App kann von jedem heruntergeladen und installiert werden – viele Inhalte sind frei zugänglich. <br/>
                            Die aktive Beteiligung – also das Schreiben von Beiträgen, das Melden von Schäden oder das Diskutieren im Bürgerforum – ist jedoch ausschließlich für Bürger und Gäste der jeweiligen Gemeinde möglich. Dies wird bei der Registrierung durch eine Überprüfung der ungefähren Geo-Position sichergestellt.
                        </p>
                    </div>
                </section>

                <UIFooter />

            </div>
        );
    }
}
